import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
export var HeaderContent = function (props) {
    var componentClass = 'header';
    var elementClass = 'content';
    var className = props.className;
    var classes = cx(className, 'd-flex', 'align-items-center', bcx(componentClass, elementClass));
    return React.createElement("div", { className: classes }, props.children);
};
//# sourceMappingURL=HeaderContent.js.map